<template>
  <div class="wrapper pt-5 lg:pt-7 xl:pt-8 pb-2">
    <div class="max-w-[1200px] relative mx-auto content container">
      <h1 class="header text-center">
        <span> Маркетплейс для аренды вещей </span>
        <span class="text-blue-600 md:whitespace-nowrap"><span class="text-black">c&nbsp;</span>безопасными сделками<img
          src="/index/smile.png"
          alt="Улыбка"
          class="w-10 h-10 inline-block ml-2"
          fetchpriority="high"
          decoding="async"
        /></span>
      </h1>
    </div>
  </div>
</template>

<script setup></script>

<style lang="sass" scoped>
  .header
    @apply text-[24px] font-bold leading-7
    @apply lg:text-[41px] leading-tight
</style>
